import "./matriculacion.scss";

export default function Matriculacion() {
  return (
    <section id="matriculacion" className="section matriculacion-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Matriculación</h2>
        <p>
          Lea atentamente los requisitos necesarios para incorporarse como
          profesional matriculado en el Colegio de Fonoaudiólogos de La Pampa.
        </p>
      </div>

      <div className="container">
        <div className="row gy-4 align-items-start">
          {/* Panel izquierdo: tarjetas informativas */}
          <div className="col-lg-4 fade-up">
            <div className="info-visual-panel">
              <div className="stat-card">
                <div className="stat-icon cyan">
                  <i className="bi bi-person-badge"></i>
                </div>
                <div className="stat-info">
                  <h4>Matrícula Provincial</h4>
                  <p>
                    Habilitación para ejercer en todo el territorio de La Pampa
                  </p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon green">
                  <i className="bi bi-hospital"></i>
                </div>
                <div className="stat-info">
                  <h4>Obras Sociales</h4>
                  <p>
                    Acceso a convenios con todas las obras sociales adheridas al
                    Colegio
                  </p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon violet">
                  <i className="bi bi-building"></i>
                </div>
                <div className="stat-info">
                  <h4>Ámbitos habilitados</h4>
                  <p>
                    Asistencial, educativo, laboral, consultorios privados y
                    domicilio
                  </p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon amber">
                  <i className="bi bi-currency-dollar"></i>
                </div>
                <div className="stat-info">
                  <h4>Arancel 2026</h4>
                  <p>Inscripción: $250.000 · Cuota mensual: $25.000</p>
                </div>
              </div>

              <div className="quote-card">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p>
                  "Es requisito indispensable para el ejercicio de la profesión
                  de Fonoaudiólogo en la Provincia, estar inscripto en la
                  matrícula cuyo registro, atención y vigilancia son a cargo del
                  Colegio."
                </p>
                <div className="quote-source">
                  Capítulo II, art. 12, Ley Nº 2558
                </div>
              </div>
            </div>
          </div>

          {/* Panel derecho: contenido */}
          <div className="col-lg-8 fade-up">
            <div className="content-panel">
              <p className="content-intro">
                El profesional fonoaudiólogo que quiera ejercer la profesión en
                cualquier ámbito de la Provincia de La Pampa deberá presentar su
                pedido de inscripción ante el Colegio de Fonoaudiólogos, para lo
                que deberá cumplir con los siguientes requisitos:
              </p>

              <h5 className="requirements-title">
                <i className="bi bi-check-circle-fill"></i>
                Requisitos generales
              </h5>
              <ul className="req-list">
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>Acreditar su identidad personal</span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Presentar Título Habilitante (Diploma y certificado
                    analítico) expedido por universidades nacionales o
                    institutos terciarios oficialmente reconocidos
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Declarar su Domicilio Real y el que constituirá con motivo
                    del ejercicio profesional
                  </span>
                </li>
              </ul>

              <h5 className="requirements-title">
                <i className="bi bi-file-earmark-text-fill"></i>
                Documentación requerida (fotocopias en A4)
              </h5>
              <ul className="req-list">
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Nota de Solicitud de Inscripción en la Matrícula (formulario
                    adjunto)
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Fotocopia de DNI con domicilio real (1ª y 2ª pág.) y cambio
                    de domicilio si lo hubiese. En caso de no figurar el
                    domicilio actualizado en el documento, presentar fotocopia
                    comprobante Impuesto o Servicio para certificar el mismo. De
                    no poseer, presentar Declaración Jurada realizada ante
                    Policía
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    TÍTULO ORIGINAL legalizado por Ministerio del Interior,
                    Universidad o Ministerio de Educación pertinente, para ser
                    sellado en el Acto de Matriculación con el número de
                    matrícula que otorgue el Colegio Profesional de
                    Fonoaudiólogos de La Pampa. El mismo será devuelto el mismo
                    día de la matriculación
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Fotocopia de Título Profesional autenticado por Escribano
                    Público
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>4 fotos carnet 4×4 color actualizadas</span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Comprobante de depósito/transferencia en concepto de Arancel
                    de Matriculación
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Constancia de CBU (Banco de La Pampa) de Caja de Ahorro o
                    Cuenta Corriente a nombre del profesional
                  </span>
                </li>
              </ul>

              <div className="account-info">
                <div className="account-label">
                  Datos bancarios para el depósito:
                </div>
                Cta. Cte. Nro. <code>100-01-441418/2</code> &nbsp;·&nbsp; CBU:{" "}
                <code>09303001 101000 44141828</code> &nbsp;·&nbsp; CUIT:{" "}
                <code>30-71151783-5</code>
              </div>

              <div className="info-box">
                <strong>Débito automático:</strong> Para adherir al débito
                automático de la cuota mensual es indispensable contar con
                cuenta en el Banco de La Pampa SEM. Adjuntar Planilla de
                Solicitud de Adhesión al DAS y constancia de CBU emitida por el
                Banco. La cuenta deberá ser la misma a la informada para el
                depósito de las liquidaciones mensuales.
              </div>

              <div className="download-actions">
                <a
                  href="/assets/portal/docs/SOLICITUD_DE_MATRICULACION.pdf"
                  className="btn-download primary"
                  target="_blank"
                >
                  <i className="bi bi-download"></i>
                  Descargar Solicitud
                </a>
                <a
                  href="/assets/portal/docs/DAS_ADHESION.pdf"
                  className="btn-download secondary"
                  target="_blank"
                >
                  <i className="bi bi-download"></i>
                  Descargar DAS Adhesión
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
